var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26240",
    "data-name": "Group 26240",
    transform: "translate(-784 -198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002-exclamation",
    "data-name": "002-exclamation",
    transform: "translate(784 198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23322",
    "data-name": "Group 23322",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23321",
    "data-name": "Group 23321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M9.243.757a6,6,0,1,0,0,8.485A6,6,0,0,0,9.243.757ZM8.536,8.535a5,5,0,1,1,0-7.071A5,5,0,0,1,8.536,8.535Z",
    transform: "translate(1 1)",
    fill: "#77b448"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_002-tick",
    "data-name": "002-tick",
    transform: "translate(787.471 202.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23302",
    "data-name": "Group 23302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M4.983,68.072a.253.253,0,0,0-.358,0L1.6,71.1.431,69.937a.253.253,0,0,0-.358.358l1.343,1.343a.253.253,0,0,0,.358,0l3.209-3.209A.253.253,0,0,0,4.983,68.072Z",
    transform: "translate(0 -67.997)",
    fill: "#77b448",
    stroke: "#77b448",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCircle);
export default __webpack_public_path__ + "static/media/mark_circle.35199a7dd8d944dc67fdf15df656dbdf.svg";
export { ForwardRef as ReactComponent };